import axios from 'axios';
import { getBlogPosts } from './Blog.action';

export class BlogDispatcher {
    requestPosts(dispatch) {
        axios
            .get('https://www.farmec.ro/compania/wp-json/wp/v2/posts?per_page=6')
            .then((res) => {
                // pass just the array of posts, not the whole response
                dispatch(getBlogPosts(res.data));
            })
            .catch((err) => {
                console.error('Blog fetch failed', err);
                // dispatch an empty list so the component can still render
                dispatch(getBlogPosts([]));
            });
    }
}

export default new BlogDispatcher();
